"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Span = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

var _customProps = require("../../../../../../utils/customProps");

/**
 * Typography
 */
var Span = function Span(_ref) {
  var align = _ref.align,
      color = _ref.color,
      height = _ref.height,
      width = _ref.width,
      rootClass = _ref.rootClass,
      content = _ref.content,
      variant = _ref.variant,
      key = _ref.key,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid;
  var defaultStyles = {
    height: height,
    width: width
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, defaultStyles);

  return /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "span",
    key: key,
    className: "".concat(styles.root, " ").concat(storyblokClass),
    variant: variant,
    align: align,
    color: color,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, " ".concat(content, " "));
};

exports.Span = Span;
var _default = Span;
exports.default = _default;
Span.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: 'inherit', 'left', 'center', 'right', 'justify'
   * Set the text-align on the component.
   * */
  align: function align(props, propName, componentName) {
    var validProps = ['inherit', 'left', 'center', 'right', 'justify'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error'
   * The color of the component. It supports those theme colors that make sense for this component.
   * */
  color: function color(props, propName, componentName) {
    var validProps = ['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** hight of the Typography element */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /** width of the Typography element */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },
  content: _propTypes.default.string.isRequired
};
Span.defaultProps = {
  width: '100%',
  height: '100%',
  align: 'inherit',
  color: 'initial',
  rootClass: []
};